import { render } from "./AdminControlCentre.vue?vue&type=template&id=4f7c366e&scoped=true"
import script from "./AdminControlCentre.vue?vue&type=script&lang=js"
export * from "./AdminControlCentre.vue?vue&type=script&lang=js"

import "./AdminControlCentre.vue?vue&type=style&index=0&id=4f7c366e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c366e"]])

export default __exports__